import { useStaticQuery, graphql } from 'gatsby';

const useTemplates = () => {
  const results = useStaticQuery(
    graphql`
      query ExtractedTemplatesQuery {
        allPaperformTemplate {
          edges {
            node {
              id
              title
              description
              form_cover_image_url
              form_slug
              key
              tags
              groups {
                id
                slug
                type
                title
              }
            }
          }
        }
      }
    `,
  );

  const { allPaperformTemplate } = results;

  return allPaperformTemplate;
};

export default useTemplates;
